


const reload = () => {
  window.location.reload()
}

export default {
  reload
}